export const calculateDiscount = (
	price: number | string | null,
	discountPrice: number | string | null,
	decimalPlaces = 2
): number | null => {
	if (!price || !discountPrice) return null
	const numericPrice = Number(price)
	const numericDiscountPrice = Number(discountPrice)
	const discount = 100 - (100 * numericDiscountPrice) / numericPrice
	if (discount === Math.floor(discount)) {
		return discount
	} else {
		return Number(discount.toFixed(decimalPlaces))
	}
}

export const calculateEcommDiscount = (
	price: number | string | null,
	discountPrice: number | string | null
): number | null => {
	if (!price || !discountPrice) return null
	return Math.floor(calculateDiscount(price, discountPrice) || 0)
}
